import { h, render } from 'preact';
import ProductRecommendationsTabs from './product-recommendations';

export default (element, data) => {
  const init = () => {
    render(<ProductRecommendationsTabs {...data} />, element);
  };

  init();
};
